module.exports = {"511903001":"登科街道","511903002":"文治街道","511903003":"司城街道","511903100":"明阳镇","511903101":"玉山镇","511903102":"渔溪镇","511903105":"花丛镇","511903106":"柳林镇","511903107":"下八庙镇","511903108":"茶坝镇","511903111":"上八庙镇","511903112":"关公镇","511903113":"兴隆镇","511903114":"双胜镇","511903115":"群乐镇","511903118":"尹家镇","511903119":"九镇","511903120":"雪山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511903.json
// module id = 2520
// module chunks = 0